import { useProduct } from '../ProductCard';
import HeartOutline from '../../../visuals/Icons/HeartOutline';
import HeartFilled from '../../../visuals/Icons/HeartFilled';
import { IconSizes } from '../../../visuals/Icons/type';
import { useTranslations } from 'next-intl';
import { forwardRef } from 'react';

interface IProductAddToWishlistProps {
  isProductInOneWishlist: boolean;
  handleClick?: (productId?: number) => void;
}

export const ProductAddToWishlist = forwardRef<
  HTMLButtonElement,
  IProductAddToWishlistProps
>(({ isProductInOneWishlist, handleClick }, ref) => {
  const product = useProduct();
  const tActions = useTranslations('Actions');

  return (
    <button
      ref={ref}
      className={`
      !tw-my-0 tw-flex
      tw-cursor-pointer
      tw-flex-col tw-items-start
      tw-space-y-0.5 tw-justify-self-end tw-border-none
      tw-bg-inherit tw-p-0
      tw-grid-area-[wishlist]
      `}
      onClick={(e) => {
        product?.inventory_available && handleClick?.(product?.id);
        e.stopPropagation();
        e.preventDefault();
      }}
      aria-label={tActions('addToWishlist')}
      type="button"
      aria-hidden // hide the Add To Wishlist Button as the popover is not accessible yet
    >
      {isProductInOneWishlist ? (
        <HeartFilled size={IconSizes.md} />
      ) : (
        <HeartOutline size={IconSizes.md} />
      )}
    </button>
  );
});
